import script from "./ActivityForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityForm.vue?vue&type=script&setup=true&lang=js"

import "./ActivityForm.vue?vue&type=style&index=0&id=45116ed6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45116ed6"]])

export default __exports__